import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { BACKEND, api, money } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileSpreadsheet } from "lucide-react";

const YEAR = new Date().getFullYear();

// Owner tax report: rent, lodging tax collected, refunds and FairStay fees per month and listing.
export function TaxReport() {
  const [year, setYear] = useState(YEAR);
  const { data } = useQuery({ queryKey: ["tax-report", year], queryFn: () => api.get(`/host/tax-report?year=${year}`).then((r) => r.data) });
  const t = data?.totals;
  return (
    <section className="mb-10 rounded-3xl border bg-white p-6" data-testid="tax-report">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2"><FileSpreadsheet className="h-5 w-5 text-primary" /><h2 className="text-lg font-semibold">Tax report</h2></div>
        <div className="flex flex-wrap items-center gap-2">
          <select className="rounded-xl border px-3 py-2 text-sm" value={year} onChange={(e) => setYear(Number(e.target.value))} data-testid="tax-report-year">
            {[YEAR + 1, YEAR, YEAR - 1].map((y) => <option key={y} value={y}>{y}</option>)}
          </select>
          <Button asChild variant="outline" className="rounded-full" data-testid="tax-report-download"><a href={`${BACKEND}/api/host/tax-report?year=${year}&format=csv`}>Download CSV</a></Button>
          <Button asChild className="rounded-full" data-testid="tax-filing-link"><Link to="/host/tax-filing">Monthly filing summary</Link></Button>
          <Button asChild variant="outline" className="rounded-full" data-testid="annual-statement-link"><Link to="/host/annual-statement">Annual statement</Link></Button>
        </div>
      </div>
      {t && (
        <p className="text-sm text-stone-700" data-testid="tax-report-totals">
          {t.stays} paid stays · rent {money(t.rent)} · lodging tax collected <span className="font-semibold">{money(t.tax_collected)}</span> · refunds on these stays {money(t.refunds)} · FairStay fees {money(t.fairstay_fee)}
        </p>
      )}
      <p className="mt-2 text-xs text-stone-500">Lodging tax charged to guests is paid into your Stripe account. You're responsible for filing and paying it to your county or city.</p>
    </section>
  );
}
